import {Pagination} from "react-admin";
import * as React from "react";

const ListPagination = (props: any) => <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]} {...props} />;

export default ListPagination;